/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_link_minecraft_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Confirm linking this Minecraft account with your BeaconAuth account.`)
};

const zh_hans1_link_minecraft_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`确认将此 Minecraft 账号与您的 BeaconAuth 账号进行关联绑定。`)
};

const zh_hant1_link_minecraft_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`確認將此 Minecraft 帳號與您的 BeaconAuth 帳號進行關聯綁定。`)
};

const fr_link_minecraft_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Confirmez la liaison de ce compte Minecraft à votre compte BeaconAuth.`)
};

const de_link_minecraft_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bestätigen Sie die Verknüpfung dieses Minecraft-Kontos mit Ihrem BeaconAuth-Konto.`)
};

const ja_link_minecraft_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`このMinecraftアカウントをBeaconAuthアカウントに連携します。`)
};

const ko_link_minecraft_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`이 Minecraft 계정을 BeaconAuth 계정과 연결합니다.`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "zh-Hans" | "zh-Hant" | "fr" | "de" | "ja" | "ko" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const link_minecraft_desc = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.link_minecraft_desc(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("link_minecraft_desc", locale)
	if (locale === "en") return en_link_minecraft_desc(inputs)
	if (locale === "zh-Hans") return zh_hans1_link_minecraft_desc(inputs)
	if (locale === "zh-Hant") return zh_hant1_link_minecraft_desc(inputs)
	if (locale === "fr") return fr_link_minecraft_desc(inputs)
	if (locale === "de") return de_link_minecraft_desc(inputs)
	if (locale === "ja") return ja_link_minecraft_desc(inputs)
	return ko_link_minecraft_desc(inputs)
};